export default __webpack_public_path__ + "static/media/green-zigzag.ba7ec228.svg";